/* eslint-disable no-unused-vars, array-bracket-newline */
import { useCallback } from 'react';
import { ICompetitionTrade } from '@kattana-io/common';
import DesktopTable from '../../../../molecules/Table/DesktopTable';
import Text from '../../../../atoms/Text';
import { useTableData } from './useTableData';
import { formatTimestamp } from '../../../../components/DexTrades/formatters';
import NumberDisplay from '../../../../molecules/NumberDisplay';

export const LS_COMPETITION_TRADES_HIDDEN_COLUMNS_KEY =
  'kattana-simple.competition_trades_table_columns_hidden';
export const LS_COMPETITION_TRADES_KEY =
  'kattana-simple.competition_trades_table_columns';

interface ICompetitionsTradesTableProps {
  trades: ICompetitionTrade[];
  timezone?: string;
  loading: boolean;
  width?: number;
}

const sellClassName = 'row--Sell text--red-600';
const buyClassName = 'row--Buy text--green-600';

/**
 * Implements a table with trades
 * @param param0
 */
const CompetitionsTradesTable = ({
  trades,
  timezone,
  width,
  loading,
}: ICompetitionsTradesTableProps) => {
  const { columns, data, tableColumnsWidth } = useTableData({
    trades,
  });

  const renderCell = (cell: any) => {
    const { Pair, FillBaseAmount } = cell.row.original;
    switch (cell.column.id) {
    case 'date':
      return <Text size={12}>{formatTimestamp(cell.value, timezone)}</Text>;
    case 'multiplier':
      return <Text size={12}>x{cell.value}</Text>;
    case 'points':
      return (
        <NumberDisplay
          value={cell.value}
          zeroValueDisplay='-'
          textProps={{ size: 12 }}
        />
      );
    case 'type':
      return <Text size={12}>{cell.value === 1 ? 'Market' : 'Limit'}</Text>;
    case 'price':
    case 'fees':
      return (
        <NumberDisplay
          value={cell.value}
          startSymbol='$'
          textProps={{ size: 12 }}
        />
      );
    case 'valueUSD':
      return (
        <Text size={12}>
          <NumberDisplay value={cell.value} string />
          &nbsp;
          <NumberDisplay
            value={FillBaseAmount}
            startSymbol='('
            endSymbol={` ${Pair})`}
            string
          />
        </Text>
      );
    default:
      return <Text size={12}>{cell.value}</Text>;
    }
  };

  const getClassNameForRow = useCallback((row: any) => {
    if (row.OrderSide === 1) {
      return buyClassName;
    }
    return sellClassName;
  }, []);

  return (
    <DesktopTable
      hiddenColumnsKey={LS_COMPETITION_TRADES_HIDDEN_COLUMNS_KEY}
      dataKey={LS_COMPETITION_TRADES_KEY}
      title='trades'
      tableColumnsWidth={tableColumnsWidth}
      tableWidth={width || 0}
      columns={columns}
      defaultSortedColumn={{ id: 'date', desc: true }}
      data={data}
      loading={loading}
      hiddenColumns={['blocknumber', 'txString', 'order']}
      getClassNameForRow={getClassNameForRow}
      renderCell={renderCell}
      hoveredKey='wallet'
    />
  );
};

export default CompetitionsTradesTable;
